var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottery-info"},[_c('van-cell-group',{attrs:{"title":" "}},[[_c('div',{staticClass:"cancel-bottom-border"},[_c('van-cell',{attrs:{"center":"","value":_vm.info,"value-class":"text-center"}})],1)]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }